import type { ResourceTileVm } from '@krp/platform-ui'
import { CASHIER_ACCESS_WINDOWS } from '@krp/resource-receipts-ui'

/**
 * Служба раздела, у которой нет ресурса-источника: в выборе источника раздела её плитка стоит рядом с плитками ресурсов.
 * Вид пакета и окно задаёт composition — платформенные привязки о них не знают (RP-SEP4).
 */
export interface SectionService {
  sectionId: string
  /** Право из «моих прав», без которого плитки нет. */
  requires: string
  /** Окно, которое открывает плитка. */
  window: string
  tile: ResourceTileVm
}

export const SECTION_SERVICES: readonly SectionService[] = [
  {
    sectionId: 'receipts',
    requires: 'platform:cashiers:read',
    window: CASHIER_ACCESS_WINDOWS.list,
    tile: { id: 'receipts-service', mark: 'ЧК', noun: 'Вход кассиров в статистику и РМК', name: 'Коды кассиров', tone: null, contactDown: false, lines: ['Коды и настройки РМК кассиров источников'] },
  },
]
